import React from 'react';

import MainLayout from '../../components/layout/Main';
import FeatureIntro from '../../components/organisms/featureIntro';
import usePageTitle from '../../hooks/usePageTitle';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import JobBoardImage from '../../assets/feature-intro-job-board.png';
import SapphireLogo from '../../assets/companies-large/sapphire.svg';
import TechstarsLogo from '../../assets/companies-large/techstars.svg';
import RedpointLogo from '../../assets/companies-large/redpoint.svg';
import IndexVenturesLogo from '../../assets/companies-large/indexVentures.svg';
import SolanaLogo from '../../assets/companies-large/solana.svg';
import LaunchTnLogo from '../../assets/companies-large/launchTn.svg';

export const JobBoardIntro = () => {
  usePageTitle('Job Board');

  return (
    <MainLayout
      containerProps={{
        pb: 0,
        minHeight: '100vh',
      }}
    >
      <MainLayoutHeader title="Job Board" />

      <FeatureIntro
        featureName="Job Board"
        title="Automatically recruit top talent with an AI Job Board"
        description="Accelerate recruiting for your community with a branded automated job board and talent network that keeps itself up-to-date and tracks conversion from job seeker to new hire."
        features={[
          'Automate job syncing from any company careers page',
          'Drive trust and talent acquisition with on brand design',
          'Measure your recruiting savings and track hire attribution',
        ]}
        image={JobBoardImage}
        imageAlt="Job Board feature preview"
        ctaText="Set up a job board"
        footerNote="Passively grow your talent network"
        logos={{
          title: 'Trusted by 850+ VC funds, chambers of commerce, career centers, and more',
          images: [
            { src: SapphireLogo, alt: 'Sapphire logo' },
            { src: TechstarsLogo, alt: 'Techstars logo' },
            { src: RedpointLogo, alt: 'Redpoint logo' },
            { src: IndexVenturesLogo, alt: 'Index Ventures logo' },
            { src: SolanaLogo, alt: 'Solana logo' },
            { src: LaunchTnLogo, alt: 'Launch Tennessee logo' },
          ],
        }}
      />
    </MainLayout>
  );
};
